
document.addEventListener('DOMContentLoaded', function () {
  const isLargeScreen = window.matchMedia('(min-width: 990px)').matches;
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Only run hover behavior on non-touch large screens
  if (isLargeScreen && !isTouchDevice) {
    document.querySelectorAll('.mega-menu').forEach((menu) => {
      const summary = menu.querySelector('summary');

      if (!summary) return;

      // Open on hover
      menu.addEventListener('mouseenter', () => {
        menu.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', () => {
        menu.removeAttribute('open');
      });

      // Prevent click toggle so it stays open on hover only
      summary.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  function updateMegaMenuWidth() {
    const navContainer = document.querySelector('.header__inline-menu');
    const megaMenus = document.querySelectorAll('.mega-menu__content .page-width');

    if (navContainer && megaMenus.length) {
      const navRect = navContainer.getBoundingClientRect();
      megaMenus.forEach(menu => {
        menu.style.width = navRect.width + 'px';
      });
    }
  }

  // Run on load
  updateMegaMenuWidth();

  // Run on window resize
  window.addEventListener('resize', updateMegaMenuWidth);
});


  document.addEventListener('DOMContentLoaded', function () {
    $('.slideshow').slick({
      autoplay: true,
      dots: false,
      arrows: false,
      autoplaySpeed: 5000,
    });
  });

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".cyber-slider").forEach(function (slider) {
    const autoplay = slider.dataset.autoplay === "true";
    const speed = parseInt(slider.dataset.speed) || 5000;
    const nav = slider.dataset.nav;

    $(slider).slick({
      dots: nav === "dots",
      arrows: nav === "arrows",
      infinite: true,
      autoplay: autoplay,
      autoplaySpeed: speed,
       fade: true, // enable fade effect
  speed: 800, // transition speed in ms
  cssEase: 'linear', // smooth fade
      prevArrow: '<button class="slick-prev slick-arrow">‹</button>',
      nextArrow: '<button class="slick-next slick-arrow">›</button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: nav === "arrows",
            dots: nav === "dots"
          }
        }
      ]
    });
  });
});


